import React from 'react';
import { Smartphone, ShieldAlert, FileCheck, Zap } from 'lucide-react'; 
import registryImg from '../assets/registry-mockup.jpg';
import permitImg from '../assets/permit-logic.jpg';
import capaImg from '../assets/capa-workflow.jpg';
import overviewImg from '../assets/overview-screen.jpg';
const FeatureRow = ({ title, desc, icon, image, reversed, theme, bullets }) => (
  <div style={{ 
    display: 'flex', flexDirection: reversed ? 'row-reverse' : 'row', 
    alignItems: 'center', gap: '80px', padding: '80px 0',
    flexWrap: 'wrap'
  }}>
    <div style={{ flex: 1, minWidth: '300px' }}>
      <div style={{ 
        width: '50px', height: '50px', background: '#eff6ff', borderRadius: '12px', 
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' 
      }}>
        {icon}
      </div>
      <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px', color: theme.secondary }}>{title}</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#475569', marginBottom: '30px' }}>{desc}</p>
      
      {/* Dynamic Bullets */}
      <ul style={{ padding: 0, listStyle: 'none' }}>
        {bullets.map((item, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', fontWeight: '500', color: '#334155' }}>
            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: theme.primary }}></div>
            {item}
          </li>
        ))}
      </ul>
    </div>
    
    {/* UPDATED IMAGE CONTAINER */}
    <div style={{ 
      flex: 1, minWidth: '300px', background: '#f1f5f9', 
      borderRadius: '24px', boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)',
      overflow: 'hidden', border: '1px solid #e2e8f0'
    }}>
      {/* Changed height to 'auto', objectFit to 'contain', and added display: 'block' */}
      <img src={image} alt={title} style={{ width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }} />
    </div>
  </div>
);

const ZigZagFeatures = ({ theme }) => {
  return (
    <section style={{ padding: '0 20px', maxWidth: '1200px', margin: '0 auto' }}>
      
      {/* Feature 1: Registry */}
      <FeatureRow 
        theme={theme}
        title="The 'No-App' Worker Registry"
        desc="Stop chasing emails. Add your worker list and track inductions, qualifications, and daily logs without them ever needing a password."
        icon={<Smartphone color={theme.primary} />}
        image={registryImg}
        bullets={['Instant Sync', 'Audit Trail', 'Export to PDF']}
      />

      {/* Feature 2: Permits */}
      <FeatureRow 
        theme={theme}
        reversed={true}
        title="Smart Permit Logic"
        desc="Don't just collect PDFs. Our permit builder uses logic jumps—if a worker selects 'Welding', the system automatically demands a hot work permit."
        icon={<FileCheck color={theme.primary} />}
        image={permitImg}
        bullets={['Conditional Logic', 'Custom Approval Chain', 'Permit Triggers from Daily Work Log']}
      />

      {/* Feature 3: CAPA */}
      <FeatureRow 
        theme={theme}
        title="Closed-Loop Corrective Actions"
        desc="When you reject a fix, the contractor gets notified instantly. Our 'Rectify & Verify' workflow ensures nothing is closed until you see the evidence."
        icon={<ShieldAlert color={theme.primary} />}
        image={capaImg}
        bullets={['Auto-Email Alerts', 'Photo Verification', 'Assign to Subcontractors']}
      />

      {/* Feature 4: Simplicity */}
      <FeatureRow 
        theme={theme}
        reversed={true}
        title="Zero-Training Interface"
        desc="Enterprise software is usually bloated and confusing. We built SiteACT for the guy in the mud, not the office. Big buttons, clear questions, and no 'admin fluff'."
        icon={<Zap color={theme.primary} />}
        image={overviewImg}
        bullets={['No User Manuals Needed', 'Works on Old Phones', 'ESL Friendly Design']}
      />

    </section>
  );
};

export default ZigZagFeatures;